module.exports = __webpack_public_path__ + "static/media/bg.1e984f43.jpg";